import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocietiesRoutingModule } from './societies-routing.module';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from 'src/app/shared/shared.module';
import { PageLayoutModule } from 'src/@core/components/page-layout/page-layout.module';
import { AddEditSocietiesComponent } from './add-edit-societies/add-edit-societies.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ViewSocietyComponent } from './view-society/view-society.component';
import { SocietyFilterDialogComponent } from './view-society/society-filter-dialog/society-filter-dialog.component';
import { BookSocietyDialogComponent } from './book-society-dialog/book-society-dialog.component';
import { BookingsComponent } from './bookings/bookings.component';
import { RequestQuoteComponent } from './request-quote/request-quote.component';
import { BookingsListComponent } from './bookings/bookings-list/bookings-list.component';
import { ViewBookingComponent } from './view-booking/view-booking.component';
import { CommonSocitiesComponent } from './common-socities/common-socities.component';
import { SocietiesComponent } from './societies.component';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from 'src/app/main-layout/main-layout.component';
import { AuthGuard } from 'src/@core/guards/auth.guard';

const routes: Routes = [
  {
    path: 'venues',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: SocietiesComponent },
      { path: 'venue-list', component: CommonSocitiesComponent },
      { path: 'view-venue/:id', component: ViewSocietyComponent },
      { path: 'add-edit-venues', component: AddEditSocietiesComponent },
      { path: 'add-edit-venues/:id', component: AddEditSocietiesComponent },
    ],
  },
  {
    path: 'bookings',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: BookingsComponent },
      { path: 'view-booking/:id', component: ViewBookingComponent },
    ],
  },
  { path: '', redirectTo: 'venues', pathMatch: 'full' },
  { path: '**', redirectTo: 'venues' }  // Handle any unknown routes
];

@NgModule({
  declarations: [SocietiesComponent, AddEditSocietiesComponent, ViewSocietyComponent, SocietyFilterDialogComponent, BookSocietyDialogComponent, BookingsComponent, RequestQuoteComponent, BookingsListComponent, ViewBookingComponent, CommonSocitiesComponent],
  entryComponents: [
    SocietyFilterDialogComponent, // Add it to the entryComponents array
    RequestQuoteComponent,
    BookingsListComponent
  ],
  imports: [CommonModule,
    //  SocietiesRoutingModule,
    RouterModule.forChild(routes),
    MatCardModule, SharedModule, PageLayoutModule, ReactiveFormsModule],
})
export class SocietiesModule { }
